import httpDao from "@/infrastructure/httpDao";
import { StaffNotificationType } from "@/lib/staff-inbox";

// スタッフ向け業務通知イベント。
// 1 イベント = 1 レコードの時系列ログで、既読はスタッフ個人単位でサーバ管理。

export interface StaffNotificationEvent {
  id: string;
  type: StaffNotificationType;
  title: string;
  body: string | null;
  linkPath: string;
  /** 詳細遷移用のバージョン付きデータ。旧通知では未設定。 */
  targetData?: unknown | null;
  createdAt: string;
  isRead: boolean;
}

export interface StaffNotificationEventList {
  items: StaffNotificationEvent[];
  total: number;
  unreadCount: number;
  page: number;
  limit: number;
}

export const staffNotificationEventRepository = {
  list: async (params?: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
    search?: string;
    type?: StaffNotificationType;
    readStatus?: "all" | "read" | "unread";
  }): Promise<StaffNotificationEventList> => {
    const res = await httpDao.get<StaffNotificationEventList>(
      "/staff-notification-events",
      {
        params: {
          ...(params?.page ? { page: params.page } : {}),
          ...(params?.limit ? { limit: params.limit } : {}),
          ...(params?.unreadOnly ? { unreadOnly: "true" } : {}),
          ...(params?.search ? { search: params.search } : {}),
          ...(params?.type ? { type: params.type } : {}),
          ...(params?.readStatus && params.readStatus !== "all"
            ? { readStatus: params.readStatus }
            : {}),
        },
      }
    );
    return res.data;
  },

  markRead: async (id: string): Promise<void> => {
    await httpDao.post(`/staff-notification-events/${id}/read`, {});
  },

  markUnread: async (id: string): Promise<void> => {
    await httpDao.post(`/staff-notification-events/${id}/unread`, {});
  },

  markAllRead: async (): Promise<void> => {
    await httpDao.post("/staff-notification-events/read-all", {});
  },
};
